var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1164_10487)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2.33496,
    width: 13.33,
    height: 13.33,
    rx: 6.665,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.35,
    y: 1.68496,
    width: 14.63,
    height: 14.63,
    rx: 7.315,
    stroke: "#344054",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1164_10487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.331 11.9995C13.331 11.5344 13.331 11.3019 13.2736 11.1126C13.1444 10.6866 12.811 10.3532 12.385 10.224C12.1958 10.1666 11.9632 10.1666 11.4981 10.1666H9.8319C9.36683 10.1666 9.13429 10.1666 8.94507 10.224C8.51904 10.3532 8.18566 10.6866 8.05642 11.1126C7.99902 11.3019 7.99902 11.5344 7.99902 11.9995M12.1646 7.5006C12.1646 8.32882 11.4932 9.00023 10.665 9.00023C9.8368 9.00023 9.1654 8.32882 9.1654 7.5006C9.1654 6.67238 9.8368 6.00098 10.665 6.00098C11.4932 6.00098 12.1646 6.67238 12.1646 7.5006Z",
    stroke: "#344054",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1164_10487",
    x: 0.700195,
    y: 0.0351562,
    width: 19.9297,
    height: 19.9297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1164_10487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1164_10487",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1164_10487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.998,
    height: 7.998,
    fill: "white",
    transform: "translate(6.66602 5.00098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/MyProfile.aa9ec210ef79f7b8162f437b1817b421.svg";
export { ForwardRef as ReactComponent };